export default {"src":"/_next/static/media/@paperclip.31bfa2d1.svg","height":24,"width":24};